import axiosInstance from 'services/interceptor';

export const getDashboardCustomer = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/customer/dashboard/`);
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};
